module.exports = __webpack_public_path__ + "static/media/AB_landing_dj_mobile.57b7effb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_landing_dj_mobile.jpg
// module id = 569
// module chunks = 0